import * as types from 'store/modules/hrms41e/mutation-types'
import hrms41e from 'api/hrms41e'
import stdtrtest from 'api/stdtrtest'
import swal from 'sweetalert'
import hrms41eLabels from 'assets/labels/hrms41e'
import { hrms41eColumns } from 'assets/columns/hrms41e'
import configLabel from 'src/../config/label'
import axios from 'axios'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  state: {
    indexDisp: true,
    detailDisp: false,
    labels: hrms41eLabels,
    columns: hrms41eColumns(),
    indexSelected: {},
    index: {
      total: 0,
      rows: []
    },
    detail: {
      tab1: {
        detail: {},
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      tab2: {
        total: 0,
        rows: []
      }
    }
  },
  getters: {
    [types.GET_HRMS41E_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS41E_DETAIL_DISP] (state) {
      return state.detailDisp
    },
    [types.GET_HRMS41E_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS41E_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS41E_INDEX] (state) {
      return state.index
    },
    [types.GET_HRMS41E_INDEX_SELECTED] (state) {
      return state.indexSelected
    },
    [types.GET_HRMS41E_DETAIL] (state) {
      return state.detail
    }
  },
  mutations: {
    [types.SET_HRMS41E_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS41E_DETAIL_DISP] (state, detailDisp) {
      state.detailDisp = detailDisp
    },
    [types.SET_HRMS41E_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
        state.columns[keyLang].detailTab2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailTab2, labels[keyLang])
      }
    },
    [types.SET_HRMS41E_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRMS41E_INDEX] (state, index) {
      state.index = index
    },
    [types.SET_HRMS41E_INDEX_SELECTED] (state, indexSelected) {
      state.indexSelected = indexSelected
    },
    [types.SET_HRMS41E_DETAIL] (state, detail) {
      state.detail = detail
    }
  },
  actions: {
    [types.TOGGLE_HRMS41E_PAGE] ({ commit }, page) {
      let indexDisp = false
      let detailDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
        case 'detail':
          detailDisp = true
          break
      }
      commit(types.SET_HRMS41E_INDEX_DISP, indexDisp)
      commit(types.SET_HRMS41E_DETAIL_DISP, detailDisp)
    },
    [types.RECEIVED_HRMS41E_COLUMNS_LABELS] ({ commit }) {
      axios.all([
        hrms41e.getLabels(),
        stdtrtest.getLabels()
      ])
      .then(axios.spread(function (responseLabels, responseLabelsStdtrtest) {
        const dataHres41e = JSON.parse(responseLabels.request.response)
        const dataStdtrtest = JSON.parse(responseLabelsStdtrtest.request.response)
        let labels = {}
        labels.en = Object.assign(dataHres41e.labels.en, dataStdtrtest.labels.en)
        labels.th = Object.assign(dataHres41e.labels.th, dataStdtrtest.labels.th)
        commit(types.SET_HRMS41E_COLUMNS, labels)
        commit(types.SET_HRMS41E_LABELS, labels)
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        swal({
          title: '', text: message, html: true, type: 'error'
        }, function () {
          window.onkeydown = null; window.onfocus = null; swal('')
        })
      })
    },
    [types.RECEIVED_HRMS41E_INDEX] ({ commit }, searchParams) {
      hrms41e.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS41E_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS41E_DETAIL] ({ commit }, searchParams) {
      hrms41e.getDetail(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS41E_DETAIL, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.POST_HRMS41E_TAB1_SAVE] ({ commit, dispatch }, { searchIndex, indexSelected, detailTab1 }) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: 'ok',
        cancelButtonText: 'cancel',
        html: true
      },
      function (isConfirm) {
        if (isConfirm) {
          swal({title: '', text: constLabels('msgWaiting'), type: 'info', showConfirmButton: false})
          hrms41e.postSaveDetailTab1({ searchIndex, indexSelected, detailTab1 })
            .then((response) => {
              const data = JSON.parse(response.request.response)
              dispatch(types.RECEIVED_HRMS41E_INDEX, searchIndex)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              swal({
                title: '', text: message, html: true, type: 'error'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms41e/index.js